import type { JSX } from 'react';
import { Button } from 'reactstrap';
import { ClearTostSvg } from 'src/assets/icons/ToasterSvg';
import { ToastOrAlertTypeSvgElement } from 'src/config/StatusIconLib';

type ToastTypes = 'success' | 'error' | 'info' | 'warning';

interface ToasterType {
  type: ToastTypes;
  theme?: 'dark' | 'light';
  icon?: ToastTypes;
  description?: string | JSX.Element;
  link?: string;
  linkLabel?: string;
  closeToast?: () => void;
  customClassName?: string;
}
const ToasterComponent = ({
  type,
  theme = 'dark',
  description = '',
  link = '',
  linkLabel = '',
  closeToast = () => {},
  icon,
  customClassName = '',
}: ToasterType) => {
  return (
    !!type && (
      <div
        className={`ls-toast  ${customClassName} has-${theme || 'dark'}`}
        data-testid={`toast-${type}`}
      >
        {icon ? <div className="ls-icon has-md">{ToastOrAlertTypeSvgElement[icon]}</div> : ''}
        <div className="ls-toast--data">
          {description || ''}
          {link ? <a href={link}>{linkLabel}</a> : ''}
          <Button onClick={closeToast} className="ls-toast-close" data-testid="toast-close-button">
            <ClearTostSvg />
          </Button>
        </div>
      </div>
    )
  );
};

export default ToasterComponent;
